import { render, staticRenderFns } from "./LmColorPicker.vue?vue&type=template&id=aae51e74&"
import script from "./LmColorPicker.vue?vue&type=script&lang=js&"
export * from "./LmColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports